(function () {
    'use strict';

    angular
        .module('app.common')
        .directive('investmentAnalysis', investmentAnalysis);


    function investmentAnalysis() {
        var directive = {
            templateUrl: '/app/common/investment-analysis.html',
            restrict: 'EA',
            scope: {
                property: '=',        // main property object (InvestmentAnalysis contains)
                showContainer: '=?',  // show/hide container style (optional)
                loading: '=?'         // Loading state (optional)
            },
            controller: ['$scope', InvestmentAnalysisController]
        };
        return directive;

        function InvestmentAnalysisController($scope) {
            // Math.abs helper
            $scope.abs = Math.abs;

            // Default showContainer to true if not provided
            if ($scope.showContainer === undefined) {
                $scope.showContainer = true;
            }

            // Central mapping: criterion row -> InvestmentPointDetails entry.
            // Returns null when the field is missing (old responses) so badges stay hidden.
            $scope.detail = function (category, key) {
                var details = $scope.property && $scope.property.InvestmentAnalysis &&
                    $scope.property.InvestmentAnalysis.InvestmentPointDetails;
                var item = details && details[category] && details[category][key];
                return (item && item.Point != null && item.MaxPoint) ? item : null;
            };
        }
    }

    angular
        .module('app.common')
        .directive('pointBadge', pointBadge);

    function pointBadge() {
        return {
            restrict: 'E',
            scope: { item: '=' },
            template:
                '<span class="point-badge" ng-if="item" ng-class="color()">' +
                '<span class="point-badge-text"><b>{{item.Point}}</b> /{{item.MaxPoint}} {{\'points\' | translate}}</span>' +
                '</span>',
            controller: ['$scope', function ($scope) {
                $scope.color = function () {
                    var ratio = $scope.item.Point / $scope.item.MaxPoint;
                    return ratio >= 0.7 ? 'green' : ratio >= 0.4 ? 'yellow' : 'red';
                };
            }]
        };
    }
})();
